import styled from "styled-components";
import { InputNumber, Table } from "antd";

export const SKF_G_004 = "#282828";
export const SKF_G_003 = "#5F5F5F";

export const TablePlug = styled(Table)`
  .ant-table {
    border: none;
    background: ${SKF_G_004};
  }
  .ant-table-cell-row-hover {
    background: ${SKF_G_004} !important;
    cursor: pointer;
  }
  thead.ant-table-thead .ant-table-cell {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid ${SKF_G_003};
    background: ${SKF_G_004};
    color: #ffffff;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    &::before {
      background-color: transparent !important;
    }
  }
  tbody.ant-table-tbody .ant-table-cell {
    border: none;
    background: ${SKF_G_004};
    color: #ffffff;
    vertical-align: top;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
  tfoot.ant-table-summary .ant-table-cell {
    border-bottom: none;
    border-top: 1px solid ${SKF_G_003};
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    &:last-child {
      text-align: right;
    }
  }
`;

export const NumberSelector = styled(InputNumber)`
  width: 88px !important;

  &.ant-input-number-group-wrapper {
    border-radius: 12px !important;
  }

  .ant-input-number-group {
    display: inline-flex;
    width: 88px;
    height: 32px;
    border: 1px solid #ffffff;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-input-number {
    width: 32px;
    min-height: 30px;
    border: 0;
    border-radius: 0 !important;
    background: ${SKF_G_004};
  }

  .ant-input-number-input {
    height: 30px;
    min-height: 30px !important;
    background: ${SKF_G_004};
    color: #fff;
    border-radius: 0 !important;
    text-align: center;
    padding: 0 !important;
    :&: hover {
      border-color: #fff;
    }
  }

  .ant-input-number-group-addon {
    width: 28px;
    min-width: 28px;
    height: 30px;
    padding: 0 !important;
    border: 0 !important;
    background: ${SKF_G_004} !important;
    color: #fff;
    line-height: 30px;
  }
`;
